var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",staticStyle:{"width":"100vw","height":"100vh"}},[_c('img',{staticStyle:{"margin-bottom":"5vh","width":"80%"},attrs:{"src":require("../assets/s2.png")},on:{"click":_vm.goWechat}})])
}
var staticRenderFns = []

export { render, staticRenderFns }